(function () {
  // ✅ Mets ici le handle de ta collection "Beatz"
  const BEATZ_URL = "/collections/beatz";

  // Essaye de détecter un "tag" cliquable (tu peux ajouter/retirer des sélecteurs)
  const TAG_SELECTORS = [
    ".tag-pill",
    ".tag",
    ".product-tag",
    ".beat-tag",
    "[data-tag]",
    "a[href*='tag=']" // au cas où
  ].join(",");

  // 1) Sur HOME (ou n'importe où) : cliquer un tag => redirection vers Beatz + tag dans l'URL
  document.addEventListener("click", (e) => {
    const tagEl = e.target.closest(TAG_SELECTORS);
    if (!tagEl) return;

    // si c’est déjà un lien normal vers autre chose, on ignore
    const isLink = tagEl.tagName === "A";
    const href = isLink ? tagEl.getAttribute("href") : "";
    if (href && href.startsWith("/") && !href.includes("tag=")) {
      // c'est un vrai lien vers une autre page
      return;
    }

    // Récupère le tag (data-tag sinon texte)
    const tag = (tagEl.getAttribute("data-tag") || tagEl.textContent || "").trim();
    if (!tag) return;

    e.preventDefault();
    e.stopPropagation();

    window.location.href = `${BEATZ_URL}?tag=${encodeURIComponent(tag)}#instru-search`;
  });

  // 2) Sur la page Beatz : lire ?tag=... => remplir la barre de recherche + scroll
  function runOnBeatzPage() {
    const params = new URLSearchParams(window.location.search);
    const tag = params.get("tag");
    if (!tag) return;

    // scroll sur l'ancre si elle existe
    const anchor = document.querySelector("#instru-search");
    if (anchor) anchor.scrollIntoView({ behavior: "smooth", block: "start" });

    // essaie de trouver l’input de recherche (plusieurs possibilités)
    const input =
      document.querySelector("#instru-search input") ||
      document.querySelector("input[type='search']") ||
      document.querySelector("input[placeholder*='Rechercher']") ||
      document.querySelector(".search input") ||
      document.querySelector(".beat-search input");

    if (!input) return;

    input.value = tag;

    // déclenche les events pour que ton filtre se lance comme si tu tapais au clavier
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("keyup", { bubbles: true }));
    input.focus();
  }

  // Lance seulement sur la collection Beatz
  if (window.location.pathname.includes("/collections/beatz")) {
    document.addEventListener("DOMContentLoaded", runOnBeatzPage);
  }
  (function () {
  function run() {
    const params = new URLSearchParams(window.location.search);
    const tag = params.get("tag");
    if (!tag) return;

    // cible la barre blanche (id recommandé)
    const input =
      document.getElementById("beatz-search") ||
      document.querySelector('input[placeholder*="instrumentale"]') ||
      document.querySelector('input[type="search"]');

    if (!input) return;

    // scroll sur la barre blanche
    input.scrollIntoView({ behavior: "smooth", block: "center" });

    // met la valeur
    input.value = tag;

    // déclenche les events (c’est ça qui lance le filtre)
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    input.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true, key: "Enter" }));

    // focus pour être sûr
    input.focus();
  }

  document.addEventListener("DOMContentLoaded", () => {
    // petit délai pour laisser ton script de filtre s’attacher à l’input
    setTimeout(run, 250);
  });
})();

})();
